// components/TaxSelect.jsx
import React from "react";

const TaxSelect = ({
  fieldName,      // "interStateTax" | "intraStateTax"
  label,          // "Inter State Tax" | "Intra State Tax"
  allTaxes,
  validation,
  handleCustomChange,
}) => {
  const value = validation.values[fieldName] || "";
  const touched = validation.touched[fieldName];
  const error = validation.errors[fieldName];
  const isDisabled = ["exempt", "nil"].includes(validation.values.taxPreference);

  const filteredTaxes = allTaxes.filter((tax) => fieldName === "interStateTax" ? tax.name.includes('IGST') : !tax.name.includes('IGST'));
  return (
    <div className="mt-3 mb-0">
      <label className="col-form-label" htmlFor={fieldName}>
        {label}
      </label>
      <select
        id={fieldName}
        name={fieldName}
        value={value}
        onChange={handleCustomChange}
        onBlur={validation.handleBlur}
        className="form-select focus-width"
        disabled={isDisabled}
        invalid={touched && error}
      >
        <option value="">Select Tax</option>
        {filteredTaxes.map((tax) => (
          <option key={tax._id} value={tax._id}>
            {tax.name}
          </option>
        ))}
      </select>
      {touched && error ? <p style={{ color: "red" }}>{error}</p> : null}
    </div>
  );
};

export default TaxSelect;